import { defineComponent as _defineComponent } from 'vue'
import CatHeader from './variants/CatHeader.vue';
import DogHeader from './variants/DogHeader.vue';
import HorseCareAndTackHeader from './variants/HorseCareAndTackHeader.vue';
import KitchenHeader from './variants/KitchenHeader.vue';
import PetHeader from './variants/PetHeader.vue';
import PoultrySuppliesHeader from './variants/PoultrySuppliesHeader.vue';
import ToolsHeader from './variants/ToolsHeader.vue';
import WrenwoodHeader from './variants/WrenwoodHeader.vue';
import { PrebuiltHeaderVariant, PrebuiltHeaderWidgetResource } from 'JS/dxp/types/widgets/prebuilt-header-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrebuiltHeaderWidget',
  props: {
    widget: null
  },
  setup(__props: any) {



return { __sfc: true,CatHeader, DogHeader, HorseCareAndTackHeader, KitchenHeader, PetHeader, PoultrySuppliesHeader, ToolsHeader, WrenwoodHeader, PrebuiltHeaderVariant }
}

})